<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Add block</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            v-on:click="$emit('update:show', false)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="add-block-filters">
            <input
              type="text"
              class="block-search"
              v-model="search"
              placeholder="Search blocks…"
            />
            <nav class="pill-nav" v-if="categories.length > 1">
              <button
                v-for="cat in categories"
                :key="cat"
                :class="{ active: activeCategory === cat }"
                v-on:click="activeCategory = cat"
              >
                {{ cat }}
              </button>
            </nav>
          </div>
          <div class="block-list">
            <div class="no-result" v-if="Object.keys(filteredBlocks).length === 0">
              No blocks match your search.
            </div>
            <div
              class="block"
              v-for="(block, id) in filteredBlocks"
              :key="block.id"
            >
              <input
                type="radio"
                name="block"
                :id="'block-' + id"
                :value="id"
                v-model="selectedBlock"
              />
              <label :for="'block-' + id">
                <div
                  class="block-icon"
                  v-html="blockIcon(id, block.icon)"
                ></div>
                <div class="block-name">{{ block.name }}</div>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer custom-input">
          <button
            class="btn btn-outline-primary"
            v-on:click="$emit('update:show', false)"
          >
            Cancel
          </button>
          <button
            class="btn btn-primary"
            :disabled="selectedBlock === undefined"
            v-on:click="addBlock"
          >
            Add block
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const bootstrap = require("bootstrap");
import http from "../../modules/http";
import {
  blockIcon as getBlockIcon,
  registerTemplateIcons,
} from "../../modules/block-icons";

export default {
  name: "AddBlock",
  props: {
    show: Boolean,
    template: Number,
  },
  emits: ["update:show", "addBlock"],
  data() {
    return {
      myModal: undefined,
      selectedBlock: undefined,
      blocks: [],
      search: "",
      activeCategory: "All",
    };
  },
  computed: {
    categories() {
      const cats = new Set();
      for (const id in this.blocks) {
        if (this.blocks[id]?.category) {
          cats.add(this.blocks[id].category);
        }
      }
      if (cats.size === 0) {
        return [];
      }
      return ["All", ...cats];
    },
    filteredBlocks() {
      const result = {};
      const search = this.search.toLowerCase();
      for (const id in this.blocks) {
        const block = this.blocks[id];
        if (
          this.activeCategory !== "All" &&
          block?.category !== this.activeCategory
        ) {
          continue;
        }
        if (
          search.length > 0 &&
          !block?.name?.toLowerCase().includes(search) &&
          !String(id).toLowerCase().includes(search)
        ) {
          continue;
        }
        result[id] = block;
      }
      return result;
    },
  },
  mounted() {
    this.myModal = new bootstrap.Modal(this.$refs.modal, {
      backdrop: "static",
    });
    if (this.show) {
      this.myModal.show();
    } else {
      this.myModal.hide();
    }
    this.loadBlocks();
  },
  unmounted() {
    // the component is mounted on demand — clean up bootstrap leftovers
    if (this.myModal) {
      this.myModal.dispose();
      this.myModal = undefined;
    }
    document
      .querySelectorAll(".modal-backdrop, .offcanvas-backdrop")
      .forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  },
  watch: {
    template() {
      this.loadBlocks();
    },
    show() {
      if (this.show) {
        this.search = "";
        this.activeCategory = "All";
        this.myModal.show();
      } else {
        this.myModal.hide();
      }
    },
  },
  methods: {
    blockIcon(typeName, fallback = null) {
      return getBlockIcon(typeName, fallback);
    },
    loadBlocks() {
      if (this.template === undefined) return;
      http
        .fetch("/themes/template/" + this.template + "/file", {
          file: "blocks.json",
        })
        .then((response) => {
          this.blocks = response;
          registerTemplateIcons(response);
        });
    },
    addBlock() {
      this.$emit("update:show", false);
      this.$emit("addBlock", this.selectedBlock);
    },
  },
};
</script>
<style scoped>
.add-block-filters {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.block-search {
  flex: 1;
  min-width: 150px;
  border: 1px solid #e2e8f0;
  border-radius: 99px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  box-sizing: border-box;
  outline-color: #7c3aed;
}
</style>
